import { useEffect } from "react";

import { useHistory } from "react-router-dom";

import { CMP_WITHOUT_ORG, DASHBOARD_HOME_URL } from "@/core/urls";

import { useAuthContext } from "./AuthProvider";
import Loading from "./Loading";

function RootRedirect() {
  const history = useHistory();
  const { user } = useAuthContext();

  useEffect(() => {
    if (user) {
      const defaultUrl = user.practitionerProfile?.id ? CMP_WITHOUT_ORG : DASHBOARD_HOME_URL;
      history.push(defaultUrl);
    }
  }, [user, history]);

  return <Loading />;
}

export default RootRedirect;
